import { useNavigate } from "react-router-dom";

export default function PropertyCard({ data }) {
  const navigate = useNavigate();

  if (!data) return null;

  return (
    <div className="flex flex-col lg:flex-row bg-white rounded-2xl shadow-sm overflow-hidden p-4">

      {/* IMAGE */}
      <div className="lg:w-[60%] h-[260px] md:h-[280px] lg:h-[420px] overflow-hidden relative">

        {/* BADGE */}
        <div className="absolute top-4 left-4 bg-[#45A301] text-white text-xs px-4 py-1.5 rounded-full shadow">
          {data.category || "Property"}
        </div>

        <img
          src={data.image}
          alt={data.title}
          className="w-full h-full object-fill lg:object-cover rounded-lg"
        />
      </div>

      {/* DETAILS */}
            <div className="lg:w-[40%] px-4 lg:px-6 py-4 flex flex-col justify-between">
              <div>
                <h3 className="text-2xl font-medium mb-6 text-[#0F172A] font-times">
                  {data.title}
                </h3>

                <div className="space-y-4 text-base">

                <div className="flex flex-col sm:flex-row sm:justify-between border-b border-[#F1F5F9] pb-2 gap-1">

                  <span className="text-[#989898]">Location</span>

                  <span className="text-[#334155] sm:text-right max-w-[70%] break-words">
                    {data.location}
                  </span>

                </div>

                <div className="flex flex-col sm:flex-row sm:justify-between border-b border-[#F1F5F9] pb-2 gap-1">
                  <span className="text-[#989898]">Size</span>
                  <span className="text-[#334155] sm:text-right">{data.size}</span>
                </div>

                <div className="flex flex-col sm:flex-row sm:justify-between border-b border-[#F1F5F9] pb-2 gap-1">
                  <span className="text-[#989898]">Road Access</span>
                  <span className="text-[#334155] sm:text-right">{data.road}</span>
                </div>

                <div className="flex flex-col sm:flex-row sm:justify-between border-b border-[#F1F5F9] pb-2 gap-1">
                  <span className="text-[#989898]">Water</span>
                  <span className="text-[#334155] sm:text-right">{data.water}</span>
                </div>

                <div className="flex flex-col sm:flex-row sm:justify-between border-b border-[#F1F5F9] pb-2 gap-1">
                  <span className="text-[#989898]">Legal Docs</span>
                  <span className="text-[#334155] sm:text-right">{data.legal}</span>
                </div>

                <div className="flex flex-col sm:flex-row sm:justify-between gap-1 pb-2.5">
                  <span className="text-[#989898]">Price</span>
                  <span className="text-[#334155] sm:text-right">{data.pricing}</span>
                </div>

              </div>
              </div>

              <button
                onClick={() =>
                  navigate(`/properties/overview/${data.id}`, {
                    state: data.id
                  })
                }
                className="mt-6 bg-[#45A301] hover:bg-[#3e9202] text-white px-6 py-2.5 rounded-md text-base w-full"
              >
                View Property Details →
              </button>
            </div>

    </div>
  );
}